import { render, staticRenderFns } from "./LeadershipExtraRequestDialog.vue?vue&type=template&id=4c6ad175&scoped=true"
import script from "./LeadershipExtraRequestDialog.vue?vue&type=script&lang=js"
export * from "./LeadershipExtraRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./LeadershipExtraRequestDialog.vue?vue&type=style&index=0&id=4c6ad175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ad175",
  null
  
)

export default component.exports